import * as Dialog from '@radix-ui/react-dialog';

import { Button } from '@/components/Button/Button';

import styles from './StudentViewErrorDialog.module.css';

interface StudentViewErrorDialogProps {
  message: string | null;
  onOpenChange(nextOpen: boolean): void;
  open: boolean;
}

/**
 * Surfaces a student-view launch failure (e.g. a blocked pop-up) in a dismissible
 * dialog rather than in the instructor control panel text.
 */
export function StudentViewErrorDialog({
  message,
  onOpenChange,
  open,
}: StudentViewErrorDialogProps) {
  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>
          <Dialog.Title className={styles.title}>
            Could not open student view
          </Dialog.Title>
          <Dialog.Description asChild>
            <p className={styles.description}>
              {message ?? 'Something went wrong opening the student view tab.'}
            </p>
          </Dialog.Description>
          <div className={styles.footer}>
            <Dialog.Close asChild>
              <Button variant="primary">Got it</Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
